// extracted by mini-css-extract-plugin
export default {"listaEquipsVisualizar":"ListaEquipamento_listaEquipsVisualizar__0ZQwx","listaParcipantesDelete":"ListaEquipamento_listaParcipantesDelete__A76q+"};